import request from '@/utils/http.js';
// 根据ID查询多因子回测
export function getDyzHcById(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getDyzHcById`,
    method: 'GET',
    params: options
  });
}

// 查询历史明细
export function getDyzHistory(options) {
  return request({
    url: `${window.config.api_v1}/backtest/getDyzHistory`,
    method: 'GET',
    params: options
  });
}
